const Services = () => {
  const servicesMain = document.querySelector(".services__main");
  const servicesBtn = document.querySelector(".services__btn");
  const servicesLink = document.querySelector(".services__link");

  if (servicesBtn && servicesMain) {
    servicesBtn.addEventListener("click", () => {
      servicesMain.classList.toggle("opened");
      servicesBtn.classList.add("d-none");
      servicesLink.classList.remove("d-none");
    })
  }
}

export default Services